export default __webpack_public_path__ + "static/media/cart.aaed5acd.svg";